















































import { Vue, Prop, Component } from 'vue-property-decorator';
import DateFormat from '@/shared/utils/date-format';

@Component({
  filters: {
    monthYear(value: string): string {
      const date: string = DateFormat.localDateToLocal(value);
      return DateFormat.fullMonthAndYear(date);
    },
  },
})
export default class OverviewMainCardCompetenceSelect extends Vue {
  @Prop({
    required: false,
    default: new Date().toISOString().substr(0, 7),
  })
  private monthProp!: string;

  private pickerMenu: boolean = false;

  private get month() {
    return this.monthProp;
  }

  private set month(value: string) {
    this.$emit('updateCompetence', value);
  }

  private clearValue(): void {
    this.$emit('updateCompetence', '');
  }
}
